<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ------------------------------------------------ ----------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">

    <div class="vx-row">
    
    <div  class="vx-col lg:w-1/3 w-full">
     <vx-card title="Room" class="mb-base">
      
       <div class="flex-1">
            <vs-input :label="$t('Name')" v-model="RoomModel.Name" class="mt-5 w-full" name="Name" v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('Name')">{{ errors.first('Name') }}</span> 
             </div>

          <div class="flex-1">
            <vs-textarea :label="$t('Description')" v-model="RoomModel.Description" class="mt-5 w-full" name="Description" v-validate="'required'" ></vs-textarea>
            <span class="text-danger text-sm" v-show="errors.has('Description')">{{ errors.first('Description') }}</span> 
             </div>
             <div class="flex-1">
                <p>{{$t('RoomType')}}</p>
          <v-select
            label="Name"
            v-model="RoomModel.RoomTypeList"
            :options="roomTypes" 
            autocomplete multiple
            class="mt-5 w-full"
            :reduce="value => value.ID"
          />
              
            </div>

        <vs-card style="margin-top:20px">
            <h4>{{$t('Attachment')}}</h4>
           <template v-if="Attachment">

          <!-- Image Container -->
          <div class="img-container w-64 mx-auto flex items-center justify-center">
            <img :src="baseURL + Attachment" alt="img" class="responsive">
          </div>
        </template>
          <!-- Image upload Buttons -->
          <div class="modify-img flex justify-between mt-5">
            <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*">
            <vs-button class="mr-4" type="flat" @click="$refs.updateImgInput.click()">{{$t('UpdateAttachment')}}</vs-button>
            <vs-button type="flat" color="#999" @click="Attachment = null;RoomModel.ImageURl=null">{{$t('RemoveAttachment')}}</vs-button>
          </div>
          </vs-card>
          
      </vx-card>
</div>
<div  class="vx-col lg:w-2/3 w-full">
    <vx-card>
          <Room-Facility class="mt-4" />
    </vx-card>
</div>
</div>
     <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
           <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">{{$t('Submit')}}</vs-button>
        <vs-button type="border" color="danger" :to="{name:'Room'}">{{$t('Cancel')}}</vs-button>
        </div>
      </div>
    </div>
    
  </div>
</template>


<script>
import vSelect from 'vue-select'
import RoomFacility from "./RoomFacility.vue";
import moduleRoom from "@/store/settings/room/moduleRoom.js";
import moduleRoomType from "@/store/settings/roomType/moduleRoomType.js";
import { domain,mainSetting } from '@/gloabelConstant.js';
 import axios from "@/axios.js"
export default {
  components: {
   RoomFacility,
     vSelect,
 
  },
  data() {
    return {
      Attachment:null,
      baseURL : domain,
       UploadRequestHeader:mainSetting.UploadRequestHeader,
       uploadUrl:domain+"API/Course/UploadFile",
      activePrompt:false,
      selected: [],
     
      itemsPerPage: 10,
      isMounted: false,
   
      // Data Sidebar
   
      RoomModel: {},
      rowDataForDelete: {},
      activeConfirm: false,
      Room_not_found :false,
      facility:{},
    };
  },
  computed: {
   
   isFormValid() {
      return !this.errors.any() && this.RoomModel.Description;
    },
 roomTypes() {
      return this.$store.state.RoomTypeList.roomTypes;
    }
  
  },

  methods: {
     updateCurrImg(input) {
      // this.RoomModel.ImageURl="";
       debugger
      if (input.target.files && input.target.files[0]) {     
        let data = new FormData()            
         data.append('file', input.target.files[0] )
         debugger
         axios.post(this.uploadUrl,data )
          .then((response) => {
            this.RoomModel.ImageURl = response.data;
             this.Attachment = response.data;
      })
      }
      },
    initValues()
    {
       this.RoomModel = {};
    },
   
     submitData() {
       debugger;
       this.RoomModel.FacilityOfRooms=this.$store.state.RoomList.RoomFacilities;
      this.RoomModel.TypeOfRooms = this.RoomModel.RoomTypeList.map(function(val){ var obj={}; obj.RoomTypeID=val; return obj; });

      this.$validator.validateAll().then(result => {
        if (result) {
         
          if (this.RoomModel.ID !== null && this.RoomModel.ID >= 0) {
            this.$store.dispatch("RoomList/updateItem", this.RoomModel).then(res => { 
               console.error(res);
              this.$router.push({name:"Room"});
           }).catch(err => {
              console.error(err);
            });
          
          } else {
            delete this.RoomModel.ID;
            this.RoomModel.popularity = 0;
            this.$store.dispatch("RoomList/addItem", this.RoomModel) 
            .then(res => { 
                console.error(res);
              this.$router.push("Room");
           }).catch(err => {
              console.error(err);
            });
              
          } 
          //this.initValues();    
        }
      });
    },

  },

  created() {
    if (!moduleRoomType.isRegistered) {
      this.$store.registerModule("RoomTypeList", moduleRoomType);
      moduleRoomType.isRegistered = true;
    }
    this.$store.dispatch("RoomTypeList/fetchDataListItems");
    if (!moduleRoom.isRegistered) {
      this.$store.registerModule("RoomList", moduleRoom);
      moduleRoom.isRegistered = true;
    }
     const ID = this.$route.params.ID
     this.$store.commit("RoomList/SET_RoomFacilities",[]);
     this.RoomModel.RoomTypeList=[];
     if(ID!=undefined)
     {

      this.$store.dispatch("RoomList/GetItemByID", ID)
      .then(res => { 
        debugger
        this.RoomModel = res.data;
        this.Attachment=res.data.ImageURl;
        this.RoomModel.RoomTypeList= this.RoomModel.TypeOfRooms.map(a=>a.RoomTypeID);

       this.$store.commit("RoomList/SET_RoomFacilities", res.data.FacilityOfRooms)

    
        debugger;
       })
      .catch(err => {
         debugger;
        if(err.response.status === 404) {
          this.Room_not_found = true
          return
        }
        console.error(err) })
     }
    
  },
  mounted() {
    this.isMounted = true;
  }
};
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
